import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../style.scss";
import { useAppContext } from "../../../../../AppContext";
import SearchDropdown from "../../../../search/seatchDropdown";
import { Value } from "sass";
const initialFieldState = {
  username: { value: "", message: "", state: null },
  password: { value: "", state: null, message: "" },
  rePassword: { value: "", message: "", state: null },
  email: { value: "", message: "", state: null },
  type: {
    value: "",
    data: [
      { value: "admin", name: "Admin" },
      { value: "user", name: "User" },
      { value: "demo", name: "Demo" },
    ],
    message: "",
    state: null,
  },
  group: {
    value: "",
    data: [],
    filteredData: [],
    searchTerm: "",
    showDropdown: false,
    message: "",
    state: null,
  },
  brand: { value: "", data: [], message: "", state: null },
  level: { value: "", data: [], message: "", state: null },
};

function CreateClient() {
  const { user, chimeraserv } = useAppContext();
  const [reset, setReset] = useState(Date.now());
  const [title] = useState("Create User | Chimera Solutions | Insights");
  const [form, setForm] = useState({ state: null, message: "" });
  const [field, setField] = useState({ ...initialFieldState });
  const [selectedGroup, setSelectedGroup] = useState(null);
  const timeRef = useRef(null);
  const groupDropdownRef = useRef(null);

  const headers = {
    Authorization: user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const renderTitle = () => (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );

  const validateFields = (fields = field) => {
    setForm((prev) => ({ ...prev, state: false }));
    if (
      fields.username.state &&
      fields.password.state &&
      fields.rePassword.state &&
      fields.email.state &&
      fields.group.state &&
      fields.level.state &&
      fields.type.state
    ) {
      setForm((prev) => ({ ...prev, state: true }));
    }
  };

  // Handle clicks outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        groupDropdownRef.current &&
        !groupDropdownRef.current.contains(event.target)
      ) {
        setField((prev) => ({
          ...prev,
          group: {
            ...prev.group,
            showDropdown: false,
          },
        }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Filter groups based on search term
  const filterGroups = (searchTerm, groups) => {
    if (!searchTerm) return groups;
    return groups.filter(
      (group) =>
        group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        group.grpKey.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  // Handle group search input
  const handleGroupSearch = (event) => {
    const searchTerm = event.target.value;
    const filteredData = filterGroups(searchTerm, field.group.data);

    setField((prev) => ({
      ...prev,
      group: {
        ...prev.group,
        searchTerm,
        filteredData,
        showDropdown: true,
        value: searchTerm, // Update value for display
        state: null, // Reset state since user is searching
      },
    }));

    // Clear selected group and related fields when searching
    setSelectedGroup(null);
    setField((prev) => ({
      ...prev,

      level: {
        ...prev.level,
        value: "",
        data: [],
        state: null,
      },
    }));

    setForm((prev) => ({ ...prev, state: false }));
  };

  // Handle group search/change
  const handleGroupChange = (event) => {
    setField((prev) => ({
      ...prev,
      group: {
        ...prev.group,
        value: event.target.value,
        state: null,
      },
    }));

    // Reset related fields when searching
    if (!event.target.value || event.target.value.length < 10) {
      setSelectedGroup(null);
      setField((prev) => ({
        ...prev,

        level: {
          ...prev.level,
          value: "",
          data: [],
          state: null,
        },
      }));
    }

    setForm((prev) => ({ ...prev, state: false }));
  };
  const handleGroupSelect = (group) => {
    const groupJson = JSON.stringify({
      name: group.name,
      grpKey: group.grpKey,
      _id: group._id,
    });

    setSelectedGroup(group);

    // Prepare brands with "All Brands" option
    const brandsWithSelectAll = [
      {
        name: "All Brands",
        braKey: "all",
        _id: "all",
      },
      ...(group.brands || []),
    ];

    setField((prev) => ({
      ...prev,
      group: {
        ...prev.group,
        value: groupJson, // Set the JSON string as value
        searchTerm: group.name, // Display selected group name
        showDropdown: false,
        state: true,
      },
      level: {
        ...prev.level,
        value: "",
        data: group.levels || [],
        state: null,
      },
    }));

    setTimeout(() => validateFields(), 100);
  };

  const checkField = (data, fields = field) => {
    clearTimeout(timeRef.current);
    timeRef.current = setTimeout(async () => {
      let updatedFields = { ...fields };
      switch (data.id) {
        case "username":
          if (data.value.length) {
            let state = true;
            let message = "";
            if (data.value.length <= 3) {
              state = false;
              message = "username should be minimum of 4 characters";
            }
            try {
              const response = await axios.get(chimeraserv.urlGet + "/user", {
                headers,
              });
              if (
                response.data.find((result) => result.username === data.value)
              ) {
                state = false;
                message = "username already exist";
              }
            } catch {}
            updatedFields.username = {
              ...updatedFields.username,
              state,
              message,
            };
            setField((prev) => ({ ...prev, username: updatedFields.username }));
          }
          break;
        case "password":
          if (data.value.length) {
            let state = true;
            let message = "";
            if (data.value.length <= 4) {
              state = false;
              message = "password should be minimum of 8 characters";
            }
            updatedFields.password = {
              ...updatedFields.password,
              state,
              message,
            };
            updatedFields.rePassword = {
              ...updatedFields.rePassword,
              state: null,
              message: "",
            };
            setField((prev) => ({
              ...prev,
              password: updatedFields.password,
              rePassword: updatedFields.rePassword,
            }));
          }
          break;
        case "rePassword":
          if (data.value.length) {
            let state = true;
            let message = "";
            if (fields.password.value !== data.value) {
              state = false;
              message = "passwords did not match";
            }
            updatedFields.rePassword = {
              ...updatedFields.rePassword,
              state,
              message,
            };
            setField((prev) => ({
              ...prev,
              rePassword: updatedFields.rePassword,
            }));
          }
          break;

        case "email":
          if (data.value.length) {
            let state = true;
            let message = "";

            const regex =
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!regex.test(String(data.value).toLowerCase())) {
              state = false;
              message = "invalid email address";
            } else {
              try {
                const response = await axios.get(chimeraserv.urlGet + "/user", {
                  headers,
                });
                if (
                  response.data.find((result) => result.email === data.value)
                ) {
                  state = false;
                  message = "email address already exist";
                }
              } catch {}
            }

            updatedFields.email = {
              ...updatedFields.email,
              state,
              message,
            };

            setField((prev) => ({
              ...prev,
              email: updatedFields.email,
            }));
          }
          break;
        case "type":
          if (data.value !== "0") {
            if (data.value === "admin") {
              updatedFields.type = {
                ...updatedFields.type,
                value: data.value,
                state: true,
              };
              updatedFields.group = {
                ...updatedFields.group,
                value: "",
                state: true,
              };
              updatedFields.level = {
                ...updatedFields.level,
                value: "0",
                state: true,
              };
            } else {
              updatedFields.type = {
                ...updatedFields.type,
                value: data.value,
                state: true,
              };
              updatedFields.group = {
                ...updatedFields.group,
                value: "",
                state: null,
              };
              updatedFields.level = {
                ...updatedFields.level,
                value: "",
                data: [],
                state: null,
              };
            }
          } else {
            updatedFields.type = {
              ...updatedFields.type,
              value: "",
              state: null,
            };
            updatedFields.group = {
              ...updatedFields.group,
              value: "",
              state: null,
            };
            updatedFields.level = {
              ...updatedFields.level,
              value: "",
              data: [],
              state: null,
            };
          }

          setField((prev) => ({
            ...prev,
            type: updatedFields.type,
            group: updatedFields.group,

            level: updatedFields.level,
          }));
          break;

        case "level":
          if (data.value !== "0") {
            updatedFields.level = {
              ...updatedFields.level,
              value: data.value,
              state: true,
            };
          } else {
            updatedFields.level = {
              ...updatedFields.level,
              value: "",
              state: null,
            };
          }

          setField((prev) => ({
            ...prev,
            level: updatedFields.level,
          }));
          break;
        default:
          break;
      }
      const delay = data.id === "email" ? 2000 : 500;
      timeRef.current = setTimeout(() => {
        setField((currentField) => {
          validateFields(currentField);
          return currentField;
        });
      }, delay);
    }, 500);
  };

  const valueChanged = (event) => {
    const element = event.target;

    //Handle group search separately
    if (element.id === "group") {
      handleGroupChange(event);

      //handleGroupSearch(event);
      return;
    }

    setField((prev) => ({
      ...prev,
      [element.id]: {
        ...prev[element.id],
        value: element.value,
        message: "",
        state: null,
      },
    }));
    setForm((prev) => ({ ...prev, state: false }));
    checkField(element, {
      ...field,
      [element.id]: {
        ...field[element.id],
        value: element.value,
      },
    });
  };

  const getGroup = async () => {
    try {
      const response = await axios.get(chimeraserv.urlGet + "/group", {
        headers,
      });

      setField((prev) => ({
        ...prev,
        group: {
          ...prev.group,
          data: response.data,
          filteredData: response.data,
        },
        brand: { ...prev.brand, data: [] },
      }));
    } catch {}
  };

  const resetForm = () => {
    setReset(Date.now());
    setField({ ...initialFieldState });
    setForm({ state: null, message: "" });
    setSelectedGroup(null);
    setTimeout(() => {
      if (user.data.type !== "admin") {
        setField((prev) => ({
          ...prev,
          type: { ...prev.type, value: "user", state: true },
        }));
      }
    }, 500);
    getGroup();
  };

  useEffect(() => {
    if (user.data.type !== "admin") {
      setField((prev) => ({
        ...prev,
        type: { ...prev.type, value: "user", state: true },
      }));
    }
    getGroup();
    // eslint-disable-next-line
  }, []);

  const checker = (state) => {
    const check = { icon: "check-circle", style: "null" };
    switch (state) {
      case true:
        check.icon = "check-circle";
        check.style = "correct";
        break;
      case false:
        check.icon = "times-circle";
        check.style = "wrong";
        break;
      default:
        break;
    }
    return check;
  };

  const submit = async () => {
    setForm((prev) => ({ ...prev, state: false, message: "" }));
    try {
      // Handle group value
      let groupValue = field.group.value;
      let groupId = null;

      // Check if we have a selected group object or need to parse JSON
      if (selectedGroup && selectedGroup._id) {
        groupId = selectedGroup._id;
      } else if (
        typeof groupValue === "string" &&
        groupValue.trim() !== "" &&
        groupValue !== "0"
      ) {
        try {
          const groupData = JSON.parse(groupValue);
          groupId = groupData._id;
        } catch (e) {
          console.error("Error parsing group value:", e);

          // If parsing fails, try to find the group by name
          const foundGroup = field.group.data.find(
            (g) => g.name.toLowerCase() === groupValue.toLowerCase()
          );
          if (foundGroup) {
            groupId = foundGroup._id;
          } else {
            throw new Error("Invalid group selection");
          }
        }
      } else {
        throw new Error("No group selected");
      }

      const response = await axios.post(
        chimeraserv.urlPost + "/user/create",
        {
          username: field.username.value,
          password: field.password.value,
          email: field.email.value,
          group: groupId, // Send the group ID
          type: field.type.value,
          level: field.level.value,
        },
        { headers }
      );

      if (response.data && !response.data.__v) {
        resetForm();
        setForm((prev) => ({
          ...prev,
          message: "User Created",
        }));
      }
    } catch (error) {
      console.error("Submit error:", error);
      setForm((prev) => ({
        ...prev,
        message: error.message || "Error creating user",
      }));
    }
  };

  const genPass = () => {
    const length = 8;
    const charset = `!@#$%^&*()-=abcdefghijklmnopqrstuvwxyz0123456789`;
    const retVal = [];
    for (let i = 0, n = charset.length; i < length; ++i) {
      let char = charset.charAt(Math.floor(Math.random() * n));
      if (Math.round(Math.random())) {
        retVal.push(char.toUpperCase());
      } else {
        retVal.push(char.toLowerCase());
      }
    }
    const password = String(retVal.join(""));
    setField((prev) => ({
      ...prev,
      password: {
        ...prev.password,
        message: `Generated new password: ${password}`,
        value: password,
        state: true,
      },
      rePassword: {
        ...prev.rePassword,
        value: password,
        state: true,
      },
    }));
    setTimeout(() => validateFields(), 100);
  };

  return (
    <div className={"custForm"}>
      {renderTitle()}
      <div className={["viewTitle"]}>Create New User</div>
      <form className={"form"}>
        <div className={["form-group"]}>
          <label htmlFor={["exampleInputEmail1"]}>
            Username <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.username.state).style].join(" ")}
            icon={["fas", checker(field.username.state).icon]}
          />
          <div className={["field"]}>
            <input
              type={"text"}
              className={["form-control"]}
              id={"username"}
              placeholder={"username"}
              value={field.username.value}
              onChange={valueChanged}
            />
            <span>{field.username.message}</span>
          </div>
        </div>

        <div className={["form-group"]}>
          <label htmlFor={["exampleInputEmail1"]}>
            Password <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.password.state).style].join(" ")}
            icon={["fas", checker(field.password.state).icon]}
          />
          <div className={["field"].join(" ")}>
            <div className={["password"].join(" ")}>
              <input
                type={"password"}
                className={["form-control"]}
                id={"password"}
                placeholder={"password"}
                value={field.password.value}
                onChange={valueChanged}
              />
              <button type={"button"} onClick={genPass}>
                <FontAwesomeIcon
                  className={["icon"].join(" ")}
                  icon={"sync-alt"}
                />
              </button>
            </div>
            <span>{field.password.message}</span>
          </div>
        </div>

        <div className={["form-group"]}>
          <label htmlFor={["exampleInputEmail1"]}>
            Re-type Password <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.rePassword.state).style].join(
              " "
            )}
            icon={["fas", checker(field.rePassword.state).icon]}
          />
          <div className={["field"].join(" ")}>
            <div className={["password"].join(" ")}>
              <input
                type={"password"}
                className={["form-control"]}
                id={"rePassword"}
                placeholder={"re-type password"}
                value={field.rePassword.value}
                onChange={valueChanged}
              />
            </div>
            <span>{field.rePassword.message}</span>
          </div>
        </div>

        <div className={["form-group"]}>
          <label htmlFor={["exampleInputEmail1"]}>
            Email Address <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.email.state).style].join(" ")}
            icon={["fas", checker(field.email.state).icon]}
          />
          <div className={["field"]}>
            <input
              type={"text"}
              className={["form-control"]}
              id={"email"}
              placeholder={"email address"}
              value={field.email.value}
              onChange={valueChanged}
            />
            <span>{field.email.message}</span>
          </div>
        </div>

        {user.data.type === "admin" ? (
          <div>
            <div className={["form-group"]}>
              <label htmlFor="type">
                User Type <span>*</span>
              </label>
              <FontAwesomeIcon
                className={["icon", checker(field.type.state).style].join(" ")}
                icon={["fas", checker(field.type.state).icon]}
              />
              <select
                className="form-control"
                id="type"
                onChange={valueChanged}
                value={field.type.value}
              >
                <option value={0}>-- type of user --</option>
                {field.type.data.map((data, key) => (
                  <option value={data.value} key={key}>
                    {data.name}
                  </option>
                ))}
              </select>
            </div>
            {field.type.state ? (
              field.type.value !== "admin" ? (
                <div>
                  <div className={["form-group"]} ref={groupDropdownRef}>
                    <label htmlFor="group">
                      Group <span>*</span>
                    </label>

                    {/* <div className="search-dropdown">
                      <input
                        type="text"
                        className="form-control"
                        id="group"
                        placeholder="Search business group..."
                        value={field.group.searchTerm}
                        onChange={valueChanged}
                        onFocus={() =>
                          setField((prev) => ({
                            ...prev,
                            group: { ...prev.group, showDropdown: true },
                          }))
                        }
                        autoComplete="off"
                      />
                      {field.group.showDropdown && (
                        <div className="dropdown-list">
                          {field.group.filteredData.length > 0 ? (
                            field.group.filteredData.map((group, key) => (
                              <div
                                key={key}
                                className="dropdown-item"
                                onClick={() => handleGroupSelect(group)}
                              >
                                <div className="group-list">{group.name}</div>
                              
                              </div>
                            ))
                          ) : (
                            <div className="dropdown-item no-results">
                              No groups found
                            </div>
                          )}
                        </div>
                      )}
                    </div>*/}
                    {/* <FontAwesomeIcon
                      className={[
                        "icon",
                        checker(field.group.state).style,
                      ].join(" ")}
                      icon={["fas", checker(field.group.state).icon]}
                    /> */}
                    <SearchDropdown
                      data={field.group.data}
                      value={field.group.searchTerm} // Use searchTerm for display
                      searchTerm={field.group.searchTerm}
                      searchFields={["name", "grpKey"]}
                      displayField="name"
                      //secondaryField="grpKey"
                      placeholder="Search business group..."
                      required={true}
                      showIcon={true}
                      error={field.group.message}
                      state={field.group.state}
                      onFocus={() => {
                        setField((prev) => ({
                          ...prev,
                          group: {
                            ...prev.group,
                            state: false,
                          },
                        }));
                      }}
                      onChange={(event) => {
                        // Handle search term changes
                        const searchTerm =
                          event.searchTerm || event.target.value;
                        const filteredData = filterGroups(
                          searchTerm,
                          field.group.data
                        );

                        setField((prev) => ({
                          ...prev,
                          group: {
                            ...prev.group,
                            searchTerm: searchTerm,
                            filteredData: filteredData,
                            showDropdown: true,
                            value: searchTerm, // Keep as search term, not JSON
                            state: true,
                          },
                        }));
                        // Clear selection if searching
                        if (!event.selectedItem) {
                          setSelectedGroup(null);
                          setField((prev) => ({
                            ...prev,
                            brand: {
                              ...prev.brand,
                              value: "",
                              data: [],
                              state: null,
                            },
                            level: {
                              ...prev.level,
                              value: "",
                              data: [],
                              state: null,
                            },
                          }));
                        }
                      }}
                      onSelect={handleGroupSelect}
                      className="form-group"
                      allowClear={true}
                      noResultsText="No groups found"
                    />
                  </div>

                  <div className={["form-group"]}>
                    <label htmlFor="level">
                      User level <span>*</span>
                    </label>
                    <FontAwesomeIcon
                      className={[
                        "icon",
                        checker(field.level.state).style,
                      ].join(" ")}
                      icon={["fas", checker(field.level.state).icon]}
                    />
                    <select
                      className="form-control"
                      id="level"
                      onChange={valueChanged}
                      value={field.level.value}
                    >
                      <option value={0}>-- level of user --</option>
                      {field.level.data.map((data, key) => (
                        <option value={data.id} key={key}>
                          {data.id} - {data.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ) : (
                <div />
              )
            ) : (
              <div />
            )}
          </div>
        ) : (
          <div>
            <div className={["form-group"]} ref={groupDropdownRef}>
              <label htmlFor="group">
                Group <span>*</span>
              </label>
              <FontAwesomeIcon
                className={["icon", checker(field.group.state).style].join(" ")}
                icon={["fas", checker(field.group.state).icon]}
              />
              <div className="search-dropdown">
                <input
                  type="text"
                  className="form-control"
                  id="group"
                  placeholder="Search business group..."
                  value={field.group.searchTerm}
                  onChange={valueChanged}
                  onFocus={() =>
                    setField((prev) => ({
                      ...prev,
                      group: { ...prev.group, showDropdown: true },
                    }))
                  }
                  autoComplete="off"
                />
                {field.group.showDropdown && (
                  <div className="dropdown-list">
                    {field.group.filteredData.length > 0 ? (
                      field.group.filteredData.map((group, key) => (
                        <div
                          key={key}
                          className="dropdown-item"
                          onClick={() => handleGroupSelect(group)}
                        >
                          <div className="group-name">{group.name}</div>
                          <div className="group-key">{group.grpKey}</div>
                        </div>
                      ))
                    ) : (
                      <div className="dropdown-item no-results">
                        No groups found
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className={["form-group"]}>
              <label htmlFor="level">
                User level <span>*</span>
              </label>
              <FontAwesomeIcon
                className={["icon", checker(field.level.state).style].join(" ")}
                icon={["fas", checker(field.level.state).icon]}
              />
              <select
                className="form-control"
                id="level"
                onChange={valueChanged}
                value={field.level.value}
              >
                <option value={0}>-- level of user --</option>
                {field.level.data.map((data, key) => (
                  <option value={data.id} key={key}>
                    {data.id} - {data.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {form.message ? (
          <div className={["message", "form-group"].join(" ")}>
            <FontAwesomeIcon
              className={["icon", "correct"].join(" ")}
              icon={"check-circle"}
            />
            {form.message}
          </div>
        ) : (
          <div />
        )}

        <button
          type={"button"}
          className={["btn btn-primary"]}
          disabled={!form.state}
          onClick={submit}
        >
          Create
        </button>
        <button
          type={"button"}
          onClick={resetForm}
          className={["btn btn-primary", "reset"].join(" ")}
        >
          Reset
        </button>
      </form>
    </div>
  );
}

export default CreateClient;
